import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { capitalize, toLower, toUpper } from 'lodash/fp';
import { resources } from 'app/locales/en-US';
import { addWordBreaks } from './lib/utils';

export { i18next };
export const i18nextConfig = {
    lng: 'en-US',
    fallbackLng: 'en-US',
    load: 'currentOnly',
    resources: { 'en-US': resources },
    ns: Object.keys(resources),
    defaultNS: 'common',
    showSupportNotice: false,
    react: {
        transEmptyNodeValue: '',
        transKeepBasicHtmlNodesFor: ['br', 'strong', 'i']
    }
};

export const initI18next = () => {
    i18next
        .use(initReactI18next)
        .init(i18nextConfig)
        .catch((e) => {
            console.error('Failed to setup i18next', e);
        });

    i18next.services.formatter.add('lowercase', toLower);
    i18next.services.formatter.add('uppercase', toUpper);
    i18next.services.formatter.add('capitalize', capitalize);
    i18next.services.formatter.add('wordbreak', addWordBreaks);

    return i18next;
};
